import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/SolutionsPliablePage.head';
import { SolutionsPliablePage } from '@pages/SolutionsPliablePage';

export const Route = createFileRoute('/solutions/pliable')({
  component: SolutionsPliablePage,
  head: () => head,
});
